import { FC } from "react";
import { CircularProgress } from "@mui/material";

import "./style.css";

interface Props {
    title: string;
    value: string;
    loading?: boolean;
    inline?: boolean;
    className?: string;
}

const TopSection: FC<Props> = ({ className, title, value, loading, inline = false }) => {
    return (
        <div className={`top_section${inline ? ` top_section_inline`: ``} ${className ? className : ""}`}>
            <div className="top_section_title">{title}</div>
            {loading ? (
                <div className="top_section_value">
                    <CircularProgress size={24} />
                </div>
            ) : (
                <div
                    className="top_section_value"
                    style={{
                        color:
                            parseFloat(value) > 0
                                ? "#00B69C"
                                : parseFloat(value) < 0
                                ? "var(--danger)"
                                : "var(--text-primary)",
                    }}
                >
                    {value}
                </div>
            )}
        </div>
    );
};

export default TopSection;
